import "./styles.css";
import "./premium.css";
import { KipsBallApp } from "./ui/app";

const root = document.querySelector<HTMLElement>("#app");

if (!root) {
  throw new Error("KipsBall app root was not found.");
}

const app = new KipsBallApp(root);
void app.start();
